import {pickProperty} from '../../../../core/graphql/graphql-utils'
import {JobRequestDetail_GetOfferingGql} from '../../../../../__generated__/types'
import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, createUrlTreeFromSnapshot, Router, RouterStateSnapshot} from '@angular/router'
import {ResolverUtilService} from '../../../../core/resolver/resolver-util.service'
import {EMPTY, Observable} from 'rxjs'
import {catchError, map} from 'rxjs/operators'
import {OTHER_OFFERING_ID} from '../../../../core/i18n/link.service'
import {OfferingResolved} from './job-request-offering.resolver'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'

/**
 * JobRequestOfferingIntentionSwitchResolver
 *
 * Redirects to legacy routes if there are no intentions.
 */
@Injectable({providedIn: 'root'})
export class JobRequestEntryStepResolver {
  constructor(
    private getOfferingGql: JobRequestDetail_GetOfferingGql,
    private util: ResolverUtilService,
    private router: Router,
  ) {}

  /*
   * We redirect the intentions in the following cases
   * 1. If intention enabled we redirect to "/intentions"
   * 2. If intentions are disabled but expectation are enabled we redirect to "/expectation"
   * 3. If intentions and expectation are disabled we redirect to "/detail"
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OfferingResolved> {
    const offeringId = route.parent?.paramMap.get('offeringId')
    if (!offeringId) {
      return this.util.redirectToNotFound(state.url, {reportError: true})
    }

    if (offeringId === OTHER_OFFERING_ID) {
      const urlTree = createUrlTreeFromSnapshot(route.parent!, [PUBLIC_ROUTES.JOB_REQUEST_DETAIL.routingPath])
      urlTree.queryParams = {
        ...route.queryParams,
      }
      this.router.navigateByUrl(urlTree)
      return EMPTY
    }

    return this.getOfferingGql.fetch({offeringId}).pipe(
      map(res => pickProperty(res.data, 'offeringById')),
      map(offering => {
        if (!hasIntention(offering)) {
          const urlTree = createUrlTreeFromSnapshot(route.parent!, [
            hasExpectations(offering)
              ? PUBLIC_ROUTES.JOB_REQUEST_CLIENT_EXPECTATION.routingPath
              : PUBLIC_ROUTES.JOB_REQUEST_DETAIL.routingPath,
          ])
          urlTree.queryParams = {
            ...route.queryParams,
          }
          this.router.navigateByUrl(urlTree)
          return undefined
        }
        return offering
      }),
      catchError(e => this.util.handleError(e, state.url)),
    )
  }
}

function hasIntention(offering: OfferingResolved): boolean {
  return !!(offering?.intentions?.length && offering?.areIntentionsEnabled)
}

function hasExpectations(offering): boolean {
  return offering.showClientExpectation
}
